import { createFileRoute } from "@tanstack/react-router";

import { DesignOperationRenderingPrototype } from "../components/prototypes/DesignOperationRenderingPrototype";

export const Route = createFileRoute("/_chat/design-operation-rendering-prototype")({
  component: DesignOperationRenderingPrototype,
  validateSearch: (search: Record<string, unknown>) => ({
    variant: typeof search.variant === "string" ? search.variant : "a",
  }),
});
